module.exports = __webpack_public_path__ + "img/ch60.5e7106a7.png";